export default __webpack_public_path__ + "static/media/frg--walking-trails.a09e611f.png";